<template>
    <div>
        <p class="text-center mb-0">{{unidadeSelecionada.cnes}} - {{unidadeSelecionada.nome}}</p>
        <p class="text-center"><strong>Enfermaria:</strong> {{dados.leitoCodigoEnfermaria}} <strong>Leito:</strong> {{dados.leitoCodigo}}</p>
        

        <div class="row">
            <div class="col-sm-12 form-group">
                 <label>Nome</label>
                 <input class="form-control" :value="dados.pacienteNome" disabled>
            </div>
        </div>

         <div class="row">
             <div class="col-sm-6 form-group">
                 <label>CNS</label>
                 <input class="form-control" :value="dados.pacienteCns" disabled>
            </div>

            <div class="col-sm-6 form-group">
                <label>Sexo</label>
                <select type="text" class="form-control" :value="dados.pacienteSexo"  disabled>
                    <option value="1">Masculino</option>
                    <option value="2">Feminino</option>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6 form-group">
                 <label>Data de Nascimento</label>
                 <input class="form-control" :value="dados.pacienteDataNascimento" disabled>
            </div>

             <div class="col-sm-6 form-group">
                <label>Idade</label>
                <input class="form-control" :value="dados.pacienteIdade" disabled>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6 form-group">
                <label>Data/Hora Admissão</label>
                <input class="form-control" :value="dados.DataHoraInternacao" disabled>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6 form-group">
                <label for="intubacao-covid">Ventilação mecânica?</label>
                <select id="intubacao-covid" class="form-control" v-model="entubado">
                    <option value="" disabled>Selecione</option>
                    <option :value="1">Sim</option>
                    <option :value="0">Não</option>
                </select>
                <small class="text-danger" v-if="entubado === ''">campo obrigatório</small>
            </div>

            <div class="col-sm-6 form-group">
                <label for="intubacao-covid">Notificado ao CIEVS?</label>
                <select id="intubacao-covid" class="form-control" v-model="cievs">
                    <option value="" disabled>Selecione</option>
                    <option :value="1">Sim</option>
                    <option :value="0">Não</option>
                </select>
                <small class="text-danger" v-if="cievs === ''">campo obrigatório</small>
            </div>
        </div>


        <button type="button" class="btn btn-primary" @click="validaSessao('notificar')" v-if="dados.covid19Renotificada === 0">Notificar COVID-19</button>
        <button type="button" class="btn btn-primary" @click="validaSessao('renotificar')" v-if="dados.covid19Renotificada === 1">Renotificar COVID-19</button>

    </div>
</template>

<script>
import { validaSessao } from '../../../shared/mixins/validaSessao'

export default {
    props: {
        dados: Object
    },
    mixins: [
        validaSessao
    ],
    data () {
        return {
            entubado: '',
            cievs: ''
        }
    },
    computed: {
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
    },
    methods: {
        notificar () {
            if (this.entubado === '' || this.cievs === '') return
            let dados = {
                idInternacao: this.dados.internacaoId,
                idLeito: this.dados.leitoId,
                suspeito: 1,
                intubado: this.entubado,
                notificado: this.cievs
            }

            this.$emit('notifica', dados)
        },
        renotificar () {
            if (this.entubado === '' || this.cievs === '') return
            let dados = {
                idInternacao: this.dados.internacaoId,
                idLeito: this.dados.leitoId,
                suspeito: 1,
                intubado: this.entubado,
                notificado: this.cievs
            }

            this.$emit('editar', dados)
        }
    }
}
</script>